module.exports = "<!-- ko with: filter -->\n<input data-bind=\"ionRangeSlider: {options: rangeSliderOptions, data: rangeSliderData}\"/>\n<div data-bind=\"visible: isSelected\">\n\t<a data-bind=\"click: reset, lang: 'btn_reset'\"></a>\n</div>\n<!-- /ko -->"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/filters/range-filter.html
// module id = voxd
// module chunks = 8 9